import request from '@utils/request';

import {
  hideLoadingModal,
  showLoadingModal,
} from '@actions/loadingModal';

const PREFIX = '[CASE DETAILS]';

export const GET_CASE_DETAILS_REQUEST = `${PREFIX} GET_CASE_DETAILS_REQUEST`;
export const GET_CASE_DETAILS_SUCCESS = `${PREFIX} GET_CASE_DETAILS_SUCCESS`;
export const GET_CASE_DETAILS_FAILURE = `${PREFIX} GET_CASE_DETAILS_FAILURE`;

const getCaseDetailsRequest = () => ({
  type: GET_CASE_DETAILS_REQUEST,
});

const getCaseDetailsSuccess = payload => ({
  type: GET_CASE_DETAILS_SUCCESS,
  payload,
});

const getCaseDetailsFailure = () => ({
  type: GET_CASE_DETAILS_FAILURE,
});

export const getCaseDetails = id => (dispatch) => {
  dispatch(getCaseDetailsRequest());
  showLoadingModal(dispatch);

  return request
    .get(`v1/cases/${id}/`)
    .then(({ data }) => dispatch(getCaseDetailsSuccess(data)))
    .catch((error) => {
      dispatch(getCaseDetailsFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};



// WEBPACK FOOTER //
// ./src/store/actions/caseDetails.js